<template>
    <div id="permissions">

        <div class="field" v-if="is_initialized">
            <label>
                Permissions
            </label>

            <table class="ui striped table">
                <tbody>
                    <tr
                        v-for="grouped_permission in grouped_permissions"
                        v-if="grouped_permission.permissions.length"
                    >
                        <td>
                            <div class="ui checkbox toggle">
                                <input type="checkbox"
                                    :id="grouped_permission.name"
                                    v-model="grouped_permission.checked"
                                    @click="toggle_permissions(
                                        $event,
                                        grouped_permission.permissions
                                    )"
                                >
                                <label :for="grouped_permission.name">
                                    {{ grouped_permission.name }}
                                </label>
                            </div>
                        </td>

                        <td>
                            <div class="ui horizontal relaxed list">
                                <div class="item" v-for="permission in grouped_permission.permissions">
                                    <div class="ui checkbox">
                                        <input type="checkbox"
                                            :id="'check'+permission.identity"
                                            :value="permission.identity"
                                            v-model="current_data.permission_identities"
                                        >
                                        <label :for="'check'+permission.identity">
                                            <!-- {{ $t("permissions_table."+permission.name) }} -->
                                            {{ permission.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderPermissionGroupsPermissionsTable",
    data: function () {
        return {
            is_initialized: false,
            grouped_permissions_array: [],
            grouped_permissions: [],
            list: [],
        }
    },
    mounted: function() {
        var that = this;

        that.init();
    },
    watch: {
        current_data_permission_identities: function() {
            var that = this;
            that.permission_checkbox_switch_permissions_toggle();
        },
        permissions: function() {
            var that = this;

            that.init();
        },
    },
    computed: {
        current_data_permission_identities: {
            cache: false,
            get: function() {
                return this.$store.state.provider.permission_groups_module.current_data.permission_identities;
            }
        },
        current_data: {
            cache: false,
            get: function() {
                return this.$store.state.provider.permission_groups_module.current_data;
            }
        },
        permissions: function() {
            return this.$store.state.provider.permission_groups_module.permissions;
        },
    },
    methods: {
        init: async function() {
            var that = this;

            await that.handle_service_config_menu_name()
            await that.init_grouped_permissions();
            await that.permission_checkbox_switch_permissions_toggle();
            await new Promise(resolve => {
                that.is_initialized = true;
                resolve();
            });
        },
        handle_service_config_menu_name: function() {
            var that = this;

            that.list = []
            _.forEach(that.$store.state.provider.service_config.menu, function(menu) {
                if (menu.items) {
                    _.forEach(menu.items, function(item) {
                        that.list.push({
                            name: that.handle_list_name_remove_string_s(item.name)
                        })
                    })
                }else {
                    that.list.push({
                        name: that.handle_list_name_remove_string_s(menu.name)
                    })
                }
            });
            return Promise.resolve();
        },
        handle_list_name_remove_string_s: function(name = null) {
            var that = this;
            try {
                if (!name) {
                    throw false
                }

                var match_name = name.match(/(.+)s/i)
                if (match_name) {
                    return match_name[1];
                } else {
                    return name;
                }
            } catch (e) {
                return false;
            }
        },
        init_grouped_permissions: function() {
            var that = this;

            that.grouped_permissions_array = []
            // var lists = [
            //     {"name": "status_prototype"},
            //     {"name": "station"},
            //     {"name": "partition"},
            //     {"name": "customer_node"},
            //     {"name": "asset"},
            //     {"name": "material"},
            //     {"name": "core_waybill"},
            //     {"name": "operation"},
            //     {"name": "permission_group"},
            //     {"name": "role"},
            //     {"name": "staff"},
            //     {"name": "appraisal"},
            //     {"name": "notification"},
            //     {"name": "permissions"},
            //     {"name": "file"},
            //     {"name": "simulate"},
            //     {"name": "dependent"},
            //     {"name": "requested"}
            // ];

            _.map(that.list, function(item) {
                item.checked = false;
                var result = [];

                // if (item.name == "work") {
                //     result.push(_.find(that.permissions, function(permission) {
                //         return permission.name == "api_v1_provider_work"
                //     }))
                // }

                _.forEach(that.permissions, function(permission) {

                    var name = item.name
                    if (name == 'user_log') {
                        name = 'log'
                    }
                    if (name == 'uploader') {
                        name = 'file'
                    }

                    if (permission.name.indexOf(name) != '-1') {
                        result.push(permission)
                        that.grouped_permissions_array.push(permission)
                    }
                })

                item.permissions = _.sortBy(result, [function(value) {
                    return value.name;
                }]);
            })

            that.grouped_permissions = that.list;
            return Promise.resolve();
        },
        toggle_permissions: function($event, objs) {
            var that = this;

            var result = _.map(objs, function(obj) {
                return obj.identity;
            })

            var identities = that.current_data.permission_identities;
            identities = (!$event.target.checked)
                ? _.pullAll(identities, result)
                : _.concat(identities, result);

            that.current_data.permission_identities = _.sortBy(_.union(identities));
        },
        permission_checkbox_switch_permissions_toggle: function() {
            var that = this;

            _.map(that.grouped_permissions, function(grouped_permission) {
                var self_permissions_all_checked = [];

                _.map(grouped_permission.permissions, function(permission) {
                    self_permissions_all_checked.push(
                        _.findLast(that.current_data.permission_identities, function(n) {
                            return n == permission.identity;
                        })
                    );
                })

                var result = _.remove(self_permissions_all_checked, _.isUndefined);
                if (result.length == 0) {
                    grouped_permission.checked = true;
                } else {
                    grouped_permission.checked = false;
                }
            })

            console.log(that.current_data.permission_identities);
            return Promise.resolve();
        },

    },
}
</script>
<style lang="scss">
    @import "../.assets/stylesheets/permissions_table.scss";
</style>
